import { endpoints } from "../config";
import { getData, postData, putData, deleteData } from "./api-utils";

const routeURL = endpoints.bilet;

const getBilet = async () => {
  return await getData(routeURL);
};
const postBilet = async (data) => {
  return await postData(routeURL, data);
};
const updateBilet = async (data, itemId) => {
  return await putData(`${routeURL}/${itemId}`, data);
};
const deleteBilet = async (itemId) => {
  return await deleteData(`${routeURL}/${itemId}`);
};

const questionRouteURL = endpoints.biletQuestions;

const getBiletQuestion = async (bilet) => {
  return await getData(`${questionRouteURL}/${bilet}`);
};

const postBiletQuestion = async (biletId, questionId) => {
  return await postData(`${questionRouteURL}`, { biletId, questionId });
};
const deleteBiletQuestion = async (biletId, questionId) => {
  return await deleteData(
    `${questionRouteURL}?question=${questionId}&bilet=${biletId}`
  );
};

export {
  getBilet,
  postBilet,
  updateBilet,
  deleteBilet,
  getBiletQuestion,
  postBiletQuestion,
  deleteBiletQuestion,
};
